import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,Stack,
  ListItem,
  ListItemText,
  Box,
  useScrollTrigger,
  Container,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoImage from "../image/Momentsia _logo.png";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
function ElevationScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
    sx: {
      backgroundColor: trigger ? "background.paper" : "transparent",
      transition: "all 0.3s ease",
    },
  });
}

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { selectedCategory } = useSelector((state) => state.eventCategories);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { label: "Services", id: "services" },
    { label: "Event Categories", id: "categories" },
    { label: "Testimonials", id: "testimonials" },
    { label: "Contact", id: "contact" },
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setMobileOpen(false);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ width: 250, pt: 2 }}>
      <List>
        {navItems.map((item) => (
          <ListItem
            button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
          >
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{ fontWeight: 500 }}
            />
          </ListItem>
        ))}
        <ListItem>
         <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
  <Button
    variant="outlined"
    fullWidth
    startIcon={<PhoneIcon />}
    onClick={() => window.location.href = "tel:+918584826222"}
  >
    Call
  </Button>
  <Button
    variant="contained"
    fullWidth
    startIcon={<WhatsAppIcon />}
    onClick={() => window.open("https://wa.me/918584826222", "_blank")}
  >
    WhatsApp
  </Button>
</Stack>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <ElevationScroll>
        <AppBar position="fixed" color="transparent">
          <Container maxWidth="lg">
            <Toolbar
              disableGutters
              sx={{ justifyContent: "space-between", py: 1 }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  component="img"
                  src={LogoImage}
                  alt="Elevate Events Logo"
                  sx={{ height: 40, mr: 1 }}
                />
                {/* <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    fontWeight: 700,
                    background:
                      "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  Elevate Events
                </Typography> */}
              </Box>

              {/* Desktop navigation */}
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  alignItems: "center",
                }}
              >
                {navItems.map((item) => (
                  <Button
                    key={item.id}
                    color="inherit"
                    sx={{
                      mx: 1,
                      fontWeight: item.id === selectedCategory ? 700 : 500,
                    }}
                    onClick={() => scrollToSection(item.id)}
                  >
                    {item.label}
                  </Button>
                ))}
                <Button
                  variant="contained"
                  sx={{ ml: 2, px: 3, borderRadius: 2 }}
                onClick={() => scrollToSection("contact")}
                >
                  Plan Your Event
                </Button>
              </Box>

              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ display: { md: "none" } }}
              >
                <MenuIcon />
              </IconButton>
            </Toolbar>
          </Container>
        </AppBar>
      </ElevationScroll>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{ display: { xs: "block", md: "none" } }}
      >
        {drawer}
      </Drawer>
      <Toolbar />
    </>
  );
};

export default Navbar;
